import type { FC } from 'react';

import type { TMessage } from '../../model/types';
import { SextingTextMessageWrapped } from './styles';

export const TextMessage: FC<{ message: TMessage; isOwn: boolean }> = ({
	message: { text, meta },
	isOwn,
}) => {
	if (meta?.isSexting && !isOwn) {
		return <SextingTextMessageWrapped>{text}</SextingTextMessageWrapped>;
	} else {
		return text;
	}
};
